import registerInitial from './_inital.directive';
import registerFullscreen from './_fullscreen.directive';
import registerGtm from './_gtm.directive';
import registerRestrict from './_restrict.directive';
import registerValidate from './_validate.directive';
import registerAutoselect from './_autoselect.directive';
import registerInputformat from './_inputformat.directive';
import registerInputtrim from './_inputtrim.directive';
import registerLazyload from './_lazyload.directive';

const isClient = typeof window !== 'undefined';

const deferredDirectiveNames = [
    'scroll', 'scrollspy', 'tip',
    'nhs', 'xlead', 'signal',
];

export default (app) => {
    registerInitial(app);
    registerFullscreen(app);
    registerGtm(app);
    registerRestrict(app);
    registerValidate(app);
    registerAutoselect(app);
    registerInputformat(app);
    registerInputtrim(app);
    registerLazyload(app);

    if (isClient) {
        const queues = {};
        for (const name of deferredDirectiveNames) {
            queues[name] = [];
            app.directive(name, {
                beforeMount(el, binding) { queues[name].push({ el, binding, hook: 'beforeMount' }); },
                mounted(el, binding) { queues[name].push({ el, binding, hook: 'mounted' }); },
                unmounted() {},
            });
        }

        const loadDeferred = () => {
            Promise.all([
                import(/* webpackChunkName: "dir-misc" */ './_scroll.directive'),
                import(/* webpackChunkName: "dir-misc" */ './_scrollspy.directive'),
                import(/* webpackChunkName: "dir-misc" */ './_tip.directive'),
                import(/* webpackChunkName: "dir-nhs" */ './_nhs.directive'),
                import(/* webpackChunkName: "dir-xlead" */ './_xlead.directive'),
                import(/* webpackChunkName: "dir-signal" */ './_signal.directive'),
            ]).then((modules) => {
                for (const name of deferredDirectiveNames) {
                    delete app._context.directives[name];
                }
                modules.forEach(m => m.default(app));

                for (const name of deferredDirectiveNames) {
                    const dir = app._context.directives[name];
                    if (!dir) continue;
                    for (const { el, binding, hook } of queues[name]) {
                        if (dir[hook] && el.isConnected) {
                            dir[hook](el, binding);
                        }
                    }
                    queues[name] = [];
                }
            });
        };
        if ('requestIdleCallback' in window) {
            requestIdleCallback(loadDeferred, { timeout: 3000 });
        } else {
            setTimeout(loadDeferred, 2000);
        }
    } else {
        const noopDir = { getSSRProps() { return {}; } };
        for (const name of deferredDirectiveNames) {
            app.directive(name, noopDir);
        }
    }
};
